/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Photo_WaitingInputs */

const en_history_photo_waiting = /** @type {(inputs: History_Photo_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploads once you’re online`)
};

const de_history_photo_waiting = /** @type {(inputs: History_Photo_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird hochgeladen, sobald du online bist`)
};

/**
* | output |
* | --- |
* | "Uploads once you’re online" |
*
* @param {History_Photo_WaitingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_photo_waiting = /** @type {((inputs?: History_Photo_WaitingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Photo_WaitingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_photo_waiting(inputs)
	return en_history_photo_waiting(inputs)
});